import { playerApiClient } from 'utils/apiClient';

export const playerUpdateDetailsErrorMessageFallback =
  'Something went wrong, please try again later';
export function getPlayerUpdateDetailsErrorMessage(
  response: Awaited<ReturnType<typeof playerApiClient.auth.updateDetails>>,
) {
  if (
    'reason' in response.body &&
    response.body.reason === 'EMAIL_ADDRESS_IN_USE'
  ) {
    return 'Email address is already in use';
  } else if (
    'bodyResult' in response.body &&
    response.body.bodyResult?.issues.some((x) => x.validation === 'email')
  ) {
    return 'Please enter a valid email address';
  }
  return undefined;
}
